import { isArdoqError } from '@ardoq/common-helpers';
import { context as Context } from 'context';
import { ARDOQ as AQ } from 'ardoq';
import { globalFilters as Filters } from 'collections/filters';
import { perspectives as Perspectives } from 'collections/perspectives';
import { action$, dispatchAction, stateStreamRegistry } from '@ardoq/rxbeach';
import { startHandlingCss } from 'utils/modelCssManager/ardoqModelCSSManager';
import { clearLoginRoutePrefix } from 'router/routerUtils';
import { startBackboneDispatchers } from 'startBackboneDispatchers';
import { startPresentationRoutines } from './startPresentationRoutines';
import { setupRouter } from './presentationRouter';
import { loadPresentationError } from './actions';
import { getStatus } from 'utils/status';
import { startStateRoutines } from './startStateRoutines';
import { initializeCurrentUser } from 'streams/currentUser/initializeCurrentUser';
import { currentUser as CurrentUser } from 'models/currentUser';
import { api, userApi } from '@ardoq/api';
import { getDefaultLocale } from '@ardoq/locale';
import { setGlobalLocale } from '../utils/localeUtils';
import { documentDoubleClickHandler } from './documentDoubleClickHandler';
import { currentUserSettled } from './streams/currentUserSettled$';
import { history } from 'router/history';

AQ.context = Context;
AQ.filters = Filters;
AQ.perspectives = Perspectives;
startBackboneDispatchers();
startPresentationRoutines(action$);

function initGlobalEvents() {
  document.body.addEventListener('dblclick', documentDoubleClickHandler);
}

const loadUserData = async () => {
  try {
    CurrentUser.initialize();
    const user = await userApi.fetchCurrentUser();
    if (isArdoqError(user)) {
      api.logErrorIfNeeded(user);
      // Set default locale for unauthenticated users in case it is a public
      // presentation
      setGlobalLocale(getDefaultLocale());
      return;
    }

    CurrentUser.startLoggedInSession();
    initializeCurrentUser(user);
  } finally {
    dispatchAction(currentUserSettled());
  }
};
/** initializes the presentation viewer web application. */
export async function initApplication() {
  try {
    clearLoginRoutePrefix();
    stateStreamRegistry.startReducing();
    startHandlingCss();
    startStateRoutines();
    loadUserData();
    const status = await getStatus();
    const startRouterPromise = setupRouter({
      isCustomDomain: Boolean(status?.['custom-domain']),
      browserHistory: history,
    }).startRouter();
    initGlobalEvents();
    await startRouterPromise;
  } catch (error) {
    dispatchAction(loadPresentationError({ error }));
  }
}
